import ButtonPrimary from '../../ButtonPrimary'

const ButtonPrimaryIcon = ({
  title,
  disabled = false,
  loading = false,
  icon = null,
  onClick = () => {},
  ...props
}) => {
  return (
    <ButtonPrimary
      {...props}
      title={title}
      icon={icon}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    />
  )
}

export default ButtonPrimaryIcon
